export enum LogicalOperators {
  And = 'AND',
  Or = 'OR',
}
